<template>
    <section class="d-flex flex-row align-items-center gap-2">
        <InputSwitch :id="id" :modelValue="internalValue"
            @update:modelValue="val => updateModel(val)" @change="$emit('change', $event)" />
        <InputLabel :forId="id">
            <slot></slot>
        </InputLabel>
    </section>
</template>
<script charset="utf-8">
import InputSwitch from "./InputSwitch.vue";
import InputLabel from "./InputLabel.vue";
export default {
    components: {
        InputSwitch,
        InputLabel
    },
    name: "InputSwitchWithLabel",

    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.updateModel(val);
            },
        },
    },
    methods: {
        updateModel(value) {
            this.$emit('update:modelValue', value);
        },
    },
}
</script>